<template>
  <div class="comp-account fit-height">
    <h1 class="headline">{{ CURRENT_USER.full_name }}</h1>

    <div class="tabs">
      <ul>
        <li>
          <router-link :to="{name: 'account'}"
            :class="{active: $route.name == 'account'}">PROFILE</router-link>
        </li>
        <li v-if="!IS_CLIENT" v-bind:class="{ 'w-badge': numberOfUnreadComments }" >
          <router-link :to="{name: 'account-notifications'}"
            :class="{active: $route.name == 'account-notifications'}">
            NOTIFICATIONS
          </router-link>
          <span v-if="numberOfUnreadComments" class="badge badge-pill badge-warning">{{ numberOfUnreadComments }}</span>
        </li>
        <li v-else class="w-badge">
          <router-link :to="{name: 'notifications'}"
                       :class="{active: $route.name == 'notifications'}">
            NOTIFICATIONS
          </router-link>
          <!--<span class="badge badge-pill badge-warning">2</span>-->
        </li>
        <li v-if="IS_SUPER_ADMIN" v-bind:class="{ 'w-badge': numberOfPendingRequests }">
          <router-link :to="{name: 'job-requests'}" :class="{active: $route.name == 'job-requests'}">JOB REQUESTS</router-link>
          <span v-if="numberOfPendingRequests" class="badge badge-pill badge-warning">{{ numberOfPendingRequests }}</span>
        </li>
      </ul>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'

  export default {
    data() {
      return {
        tabs: [
          {value: 'account', label: 'PROFILE'},
          {value: 'account-notifications', label: 'NOTIFICATIONS'},
          {value: 'job-requests', label: 'JOB REQUESTS'},
        ],
      }
    },
    watch: {},
    computed: {
      ...mapGetters(['IS_CLIENT', 'CURRENT_USER', 'IS_SUPER_ADMIN']),
      ...mapState({
        numberOfUnreadComments: state => state.option.numberOfUnreadComments,
        numberOfPendingRequests: state => state.option.numberOfPendingRequests
      })
    },
    created() {
    },
    mounted() {
    },
    methods: {
      init() {

      }
    }
  }
</script>
